module.exports = __webpack_public_path__ + "assets/img/404_wechat.78c8a540.svg";